<div class="modal-header">
  <h4 class="modal-title d-block">Why you need to update your pet details?</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()">
  </button>
</div>

<div class="modal-body">
  <div class="row mt-2">
    <div class="col-12">
      <p>
        We are always sorry to hear about pets passing away.
      </p>
      <p>
        However, we are often the last to learn of this event as your vet is not obliged to tell us.
      </p>
      <p>
        We would therefore, kindly remind you to update your online account
      </p>
      <p>
        <a [routerLink]="[]" (click)="navigateToMyPets()">Update my pets</a>
      </p>
      <p>
        or contact us to let us know so your pets record can be updated and you can avoid any future communications regarding your pet.
      </p>
    </div>
  </div>
</div>
